import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import formStyles from '../../../styles/forms.module.scss';
import {
  TextInput,
  RadioGroupInput,
  AccessibleDatepickerInput,
} from '../../../common/FormFields';
import Heading from '../../../common/Heading';
import { readInformationStartDate } from '../../../utils/coerce';
import s from './StepCertificateForm.module.scss';

type ProofOfOriginCertificateField = 'consumption' | 'certification' | 'origin';

function StepProofOfOriginForm() {
  const namePrefix = 'proofOfOriginCertificateData.';
  const fieldName = (field: ProofOfOriginCertificateField) =>
    `${namePrefix}${field}`;

  return (
    <section>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepProofOfOrigin.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="information.start"
            labelMsg="offerWizard.StepSomeInformation.start.label"
            component={AccessibleDatepickerInput}
            minDate={new Date()}
          />
          <Field
            name="information.end"
            labelMsg="offerWizard.StepSomeInformation.end.label"
            component={AccessibleDatepickerInput}
            minDate={(values: Record<string, unknown>) => {
              const start = readInformationStartDate(values);
              if (start) {
                return new Date(start);
              }
              return new Date();
            }}
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('consumption')}
            component={TextInput}
            labelMsg="offerWizard.StepProofOfOrigin.consumption.label"
          />
        </div>
        <Field
          captionMsg="offerWizard.StepProofOfOrigin.certification"
          name={fieldName('certification')}
          options={[
            {
              value: 'ee',
              labelText: 'TÜV Süd EE',
            },
            {
              value: 'ee_plus',
              labelText: 'TÜV Süd EE+',
            },
            {
              value: 'ee_new',
              labelText: 'TÜV Süd EE neu',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.certificationRadios}
        />
        <Field
          captionMsg="offerWizard.StepProofOfOrigin.origin"
          name={fieldName('origin')}
          options={[
            {
              value: 'de',
              labelText: 'Deutschland',
            },
            {
              value: 'de_at_ch',
              labelText: 'D-A-CH',
            },
            {
              value: 'eu',
              labelText: 'Europa',
            },
            {
              value: 'at',
              labelText: 'Österreich',
            },
            {
              value: 'de_at_ch_fr',
              labelText: 'D-A-CH + Frankreich',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.originRadios}
        />
      </div>
    </section>
  );
}

export default StepProofOfOriginForm;
